// extracted by mini-css-extract-plugin
module.exports = {"container":"ResponsiveVideo-module--container--3mhys","iframe":"ResponsiveVideo-module--iframe--1RCPP"};